import { render, staticRenderFns } from "./ticket-statistics-container.vue?vue&type=template&id=7f07076e&scoped=true"
import script from "./ticket-statistics-container.vue?vue&type=script&lang=js"
export * from "./ticket-statistics-container.vue?vue&type=script&lang=js"
import style0 from "./ticket-statistics-container.vue?vue&type=style&index=0&id=7f07076e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07076e",
  null
  
)

export default component.exports